import React, { PureComponent } from 'react';
import Loadable from 'react-loadable';

const LoadStatic = Loadable({
    loader: () => import('./index.jsx'),
    loading() {
        return <div>Loading...</div>;
    },
});

export default class Static extends PureComponent {
    render() {
        return (
            <div style={{ position: 'relative' }}>
                <LoadStatic {...this.props} />
            </div>
        );
    }
}
